import type { ComponentProps } from "react";

import { cn } from "@/shared/lib";

export const SidebarFooter = ({ className, ...props }: ComponentProps<"div">) => (
  <div
    data-slot="sidebar-footer"
    className={cn(
      "mx-3 flex flex-col gap-2.5 border-t border-border pt-3.5 pb-5 group-data-[state=collapsed]/sidebar:items-center",
      className,
    )}
    {...props}
  />
);
